import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';
import Header2 from './header2';
import Footer from './footer';

function Preview() {
  // const vi = useRef(null);
  const navigate = useNavigate();
  const {did}  = useParams();
  const fileInputRef = useRef(null); // Reference for file input

  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [showModal, setShowModal] = useState(false);
  // const [products, setProducts] = useState([]);
  const [category, setCategory] = useState({});
  const [categoryName, setCategoryName] = useState('');

  const [design, setDesigns] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [order, setOrder] = useState({
    u_name: '',
    email: '',
    contact: '',
    attach: [],
    desc: '',
     quantity: '',
      specification: ''
  });
  
  
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [errors, setErrors] = useState({}); // State for input errors
  const [previewImage, setPreviewImage] = useState(null);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  

  // Correct credentials (Replace with your actual authentication logic)
  const correctUsername = "admin";
  const correctPassword = "123";

 
  // Handle login
  const handleLogin = () => {
      if (username === correctUsername && password === correctPassword) {
          navigate(`/collection/${did}`); // Redirect if login is correct
      } else {
          setError("Invalid username or password");
      }
  };

  useEffect(() => {
    const fetchDesignDetails = async () => {
      try {
        const response = await axios.post(`${baseURL}/api/design-fetch-did`, { did });
        setDesigns(response.data[0]);
        setCategory(response.data[0].pid); // ✅ Safe here

        fetchProductsDetails(response.data[0].pid);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchCategory = async () => {

      try {
        const response = await axios.get(`${baseURL}/api/product`);
        setCategory(response.data);
      } catch (err) {
        console.error('Error fetching designs:', err);
      }
    };


    const fetchProductsDetails = async (categoryId) => {
      try {
        const response = await axios.post(`${baseURL}/api/product-fetch`, { productId: categoryId });
        setCategoryName(response.data[0].pname);
      } catch (error) {
        console.error(error);
      }
    };


    fetchCategory();
    fetchDesignDetails();
  }, [did]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOrder({
      ...order,
      [name]: value,
    });
    setErrors((prev) => ({ ...prev, [name]: false })); // Remove error if input is updated
  };


  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const filePreviews = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setOrder((prevOrder) => ({
      ...prevOrder,
      attach: [...prevOrder.attach, ...filePreviews],
    }));
  };

  const handleFileClick = () => {
    fileInputRef.current.click();
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = [...order.attach];
    updatedFiles.splice(index, 1);
    setOrder((prevOrder) => ({
      ...prevOrder,
      attach: updatedFiles,
    }));
  };

  const handlePreviewClick = (preview) => {
    setPreviewImage(preview);
  };

  const closeModal = () => {
    setPreviewImage(null);
  };
  // const handleFileChange = (e) => {
  //   setOrder({
  //     ...order,
  //     attach: e.target.files[0],
  //   });
  //   setErrors((prev) => ({ ...prev, attach: false })); // Remove error for file input
  // };

  const handlSubmit = async (e) => {
    e.preventDefault();
  
    // Validate inputs
    let formErrors = {};
    if (!order.u_name) formErrors.u_name = true;
    if (!order.email) formErrors.email = true;
    if (!order.contact) formErrors.contact = true;
    if (!order.attach || order.attach.length === 0) formErrors.attach = true;
    if (!order.quantity) formErrors.quantity = true;
    if (!order.specification) formErrors.specification = true;
  
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
  
    const formdata = new FormData();
    formdata.append('pid', design.pid);
    formdata.append('did', design.did);
    formdata.append('u_name', order.u_name);
    formdata.append('email', order.email);
    formdata.append('contact', order.contact);
    formdata.append('quantity', order.quantity);
    formdata.append('specification', order.specification);
    formdata.append('desc', order.desc || '');
  
    // Append each file to the form data
    order.attach.forEach((file, index) => {
      formdata.append(`attach[${index}]`, file.file);
    });
  
    try {
      const response = await axios.post(`${baseURL}/api/placed-order`, formdata, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.status === 200) {
        setNotification({ message: 'Order placed successfully!', type: 'success' });
        setTimeout(() => {
          navigate('/'); // Redirect to the home route after 3 seconds
        }, 3000);
      }
    } catch (error) {
      console.error('Error placing order:', error);
    }
  };
  

  return (
    <>
      <Header2 />
      <div className="container preview-container">
      <div>
          <ul className="design-menu">
            <li>
              <Link to={`/`} className="submenu">Home</Link>
            </li>
            <li className="submenu">/</li>
            <li className="submenu active-submenu" style={{cursor:'po'}}>
  <div
    className="hover-wrapper"
    onMouseEnter={() => setShowModal(true)}
    onMouseLeave={() => setShowModal(false)}
    style={{ position: 'relative', display: 'inline-block' }}
  >
   {categoryName}
    {showModal && (
      <div className="modal-tooltip show">
      <div style={{textAlign:'left'}}>
      <Link to={`/design/1`} style={{color:'black'}}> <p>  Business Stationery</p></Link>
      <Link to={`/design/2`} style={{color:'black'}}> <p> Marketing Collateral</p></Link>
      <Link to={`/design/3`} style={{color:'black'}}> <p>Gifts</p></Link>
      <Link to={`/design/4`} style={{color:'black'}}> <p>Decor</p></Link>

       
       </div>
      {/* Add more details here if needed */}
    </div>
    )}
  </div>
</li>
<li className="submenu">/</li>
<li className="submenu">{design.dname}</li>
          </ul>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <img src={`${baseURL}/images/${design.image}`} className="design-image" alt="Design" />
          </div>
          <div className="col-sm-6">
          <h4 className="title-get-quote">GET A QUOTE</h4>
        {notification.message && (
          <div className={`alert alert-success notification ${notification.type}`}>
            {notification.message}
          </div>
        )}
            <p className="preview-design-name">{design.dname}</p>
            
            <div className="quote-div">
              <form onSubmit={handlSubmit}>
              <div className={`form-group row form-control-group ${errors.email ? 'input-error' : ''}`}></div>

              <div className="form-group row form-control-group" style={{padding:'0px'}}>
                  <label className="label-get-qoute">Specifications:</label>
                  <textarea
                    className="form-control"
                    name="specification"
                    value={order.specification}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
                <div className="form-group row form-control-group" style={{padding:'0px'}}>
                  <label className="label-get-qoute">Quantity:</label>
                  <input
                    type="number"
                    className="form-control"
                    name="quantity"
                    style={{width:'39%'}}
                    value={order.quantity}
                    onChange={handleInputChange}
                  />
                </div>
                
                <label className="label-get-qoute" style={{fontSize:'15px'}}>Attach Files:</label>
                <div className={`form-group row form-control-group ${errors.attach ? 'input-error' : ''}`} style={{display:'flex', flexWrap:'nowrap'}}>
                <div style={{
    width: '30%',
    textAlign: 'center',
    padding: '10px',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    margin: '10px',
    backgroundColor: '#fff'
}}>
    <img src={`${baseURL}/images/upload.svg`} 
        style={{ width: '100%', cursor: 'pointer' }} 
        alt="Login"  
        onClick={handleFileClick} 
    />
    <p style={{paddingTop:'10px'}}>UPLOAD YOUR FILES</p>
</div>

<div style={{
    width: '30%',
    textAlign: 'center',
    padding: '10px',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    margin: '10px',
    backgroundColor: '#fff'
}}>
 <Link to={`/collection/${did}`}>
    <img 
        src={`${baseURL}/images/browse2.svg`} 
        style={{ width: '100%', cursor: 'pointer' }} 
        alt="Login" 
    />
</Link>

    <p style={{paddingTop:'10px'}}>EXPLORE OUR IMAGES</p>
</div>


                </div>
                <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        multiple
        accept="image/*"
      />
      <div className='uploadfileNanme' style={{ marginBottom: '10px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        {order.attach.length > 0 ? (
          order.attach.map((item, index) => (
            <div key={index} style={{ position: 'relative', width: '100px' }}>
              <img
                src={item.preview}
                alt={`Preview ${index}`}
                style={{ width: '100%', height: '100px', objectFit: 'cover', cursor: 'pointer' }}
                onClick={() => handlePreviewClick(item.preview)}
              />
              <button
                onClick={() => handleRemoveFile(index)}
                style={{
                  position: 'absolute',
                  top: '5px',
                  right: '5px',
                  background: 'red',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '17px',
                  height: '17px',
                  cursor: 'pointer',
                  fontSize:'10px',
                }}
              >
                ✕
              </button>
            </div>
          ))
        ) : (
          <div></div>
        )}
      </div>
              
                
                <h5 style={{marginLeft:'-13px', fontSize:'17px'}}><u>Add your contact details:</u></h5>
                <div className={`form-group row form-control-group ${errors.u_name ? 'input-error' : ''}`}>
                  <label className="label-get-qoute">Name:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="u_name"
                    value={order.u_name}
                    onChange={handleInputChange}
                  />
                </div>
                <div className={`form-group row form-control-group ${errors.contact ? 'input-error' : ''}`}>
                  <label className="label-get-qoute">Contact:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="contact"
                    value={order.contact}
                    onChange={handleInputChange}
                  />
                </div>
                <div className={`form-group row form-control-group ${errors.email ? 'input-error' : ''}`}>
                  <label className="label-get-qoute">Email:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="email"
                    value={order.email}
                    onChange={handleInputChange}
                  />
                </div>
                
                {/* <div className="form-group row form-control-group">
                  <label className="label-get-qoute">Description:</label>
                  <textarea
                    className="form-control"
                    name="desc"
                    value={order.desc}
                    onChange={handleInputChange}
                  ></textarea>
                </div> */}
                <input type="submit" className="btn enquire-button" name="submit" value="Submit" />
              </form>
            </div>
          </div>
        </div>
      </div>


       {/* Login Modal */}
       {isModalOpen && (
                <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{textAlign:'left'}}>
                        <button className="close-btn" onClick={() => setIsModalOpen(false)}>×</button>
                        <label style={{color:'black'}}>User Name:</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                         <label style={{color:'black'}}>Password:</label>
                        <input
                            type="password"
                            placeholder="Password"
                             className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        {error && <p className="error">{error}</p>}
                        <br />
                        <button className="login-btn btn-sm-primary" onClick={handleLogin}>Login</button>
                    </div>
                </div>
            )}

{previewImage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
          onClick={closeModal}
        >
          <img
            src={previewImage}
            alt="Preview"
            style={{ maxWidth: '90%', maxHeight: '90%', border: '5px solid white', borderRadius: '10px' }}
          />
        </div>
      )}
      <Footer />
    </>
  );
}

export default Preview;
